import ReportCourierScreen from './index';

const routes = [
  {
    path: '/report/weekly',
    component: ReportCourierScreen,
    action: ['manage', 'read_only'],
    service: ['nvo.tms.report'],
  },
];

export default routes;
